import React, { useState, useEffect, useRef } from "react";
import ArrowIcon from "./ArrowIcon"; // Adjust the import path as necessary
import QrCodeComponent from './left-qr-code-component'; // Adjust the import according to your project structure
import { calculateMidPoint } from '../main-container/markCurrentPosition';
import CustomPopup from '../main-container/DirectionPopup';
import { useLocation } from 'react-router-dom';
import { getEndOftheDay } from '../main-container/DateTimeUtils';
import { manageLayers, removeCurrentPosition, markCurrentPosition } from '../main-container/markCurrentPosition'; // Import the functions
import { listAllAvailableLevels } from '../main-container/utilityMethods'; // Import the functions
import { useMap } from '../../../context/MapContext'; // Import the useMap hook
import SelectedMarker from "./SelectedMarker";
import leftNav from '../../../../assets/images/left-nav.svg';
import rightNav from '../../../../assets/images/right-nav.svg';

const LeftContainer = ({ zoneData, showPopup, hidePopup, tenantId, locationId, qrCodeExpiresAt = 1733011199 ,showLevelSelector = false, defaultLevel, defaultBuilding, whereAmILevel, whereAmIBuilding, setBuilding, setLevel, handleResetView, lat, long, rotation,isZonesInfoPopulated,isDestFidPopulated=false,selectedFloor, setSelectedFloor, buildingInfo, defaultBuildingTitle="Melbourne Convention and Exhibition Center", defaultActiveTab=0, centerLatLong,eventName,pitch=65,bearing=-70, floorColourMapping, whereAmIScale=150.091301692798277e-8,signageNum, floorNameMapping}) => {
  const { map } = useMap();
  const [buildingName, setBuildingName] = useState("Mandalay Bay");
  const [levelName, setLevelName] = useState("The Hub");

  const [activeTab, setActiveTab] = useState(defaultActiveTab); // State to track active tab
  const [buildings, setBuildings] = useState([]);
  const [selectedLevels, setSelectedLevels] = useState({}); // Track selected levels per tab
  const [enableLevelSelector, setEnableLevelSelector] = useState(showLevelSelector);

  const [expandedZone, setExpandedZone] = useState(null);
  const [isQrCodeGenerated, setIsQrCodeGenerated] = useState(false);
  const [isZonesPopulated, setIsZonesPopulated] = useState(isZonesInfoPopulated);

  
  const [zones, setZones] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const gridRef = useRef(null);
  const [atBottom, setAtBottom] = useState(false);

  const handleTap = () => {
    setIsActive(!isActive);
  };



  const zoneColorMapping = {
    'Build Your Brand': "#FFFFFF",
    'Cisco Showcase': "#4AA4DC",
    'Competetive Intelligence': "#2F6237",
    'Customer Experience': "#367B84",
    'People & Purpose': "#D6368E",
    'Partner Showcase': "#255AA5",
    'DevNet': "#EBAB42",
    'Sales Enablement': "#81BE66",
    'Solutions Engineers': "#E47C3A",
  };
  /**
    const zones = [
      {
        index: 1,
        title: "Build Your Brand",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin interdum, ipsum a fermentum cursus, sapien turpis condimentum lacus, et vehicula augue libero nec lorem.",
        color: "#FFFFFF",
      },
      {
        index: 2,
        title: "Cisco Showcase",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin interdum, ipsum a fermentum cursus, sapien turpis condimentum lacus, et vehicula augue libero nec lorem.",
        color: "#4AA4DC",
      },
      {
        index: 3,
        title: "Competetive Intelligence",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin interdum, ipsum a fermentum cursus, sapien turpis condimentum lacus, et vehicula augue libero nec lorem.",
        color: "#2F6237",
      },
      {
        index: 4,
        title: "Customer Experience",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin interdum, ipsum a fermentum cursus, sapien turpis condimentum lacus, et vehicula augue libero nec lorem.",
        color: "#367B84",
      },
      {
        index: 5,
        title: "People & Purpose",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin interdum, ipsum a fermentum cursus, sapien turpis condimentum lacus, et vehicula augue libero nec lorem.",
        color: "#D6368E",
      },
      {
        index: 6,
        title: "Partner Showcase",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin interdum, ipsum a fermentum cursus, sapien turpis condimentum lacus, et vehicula augue libero nec lorem.",
        color: "#255AA5",
      },
      {
        index: 7,
        title: "DevNet",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin interdum, ipsum a fermentum cursus, sapien turpis condimentum lacus, et vehicula augue libero nec lorem.",
        color: "#EBAB42",
      },
      {
        index: 8,
        title: "Sales Enablement",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin interdum, ipsum a fermentum cursus, sapien turpis condimentum lacus, et vehicula augue libero nec lorem.",
        color: "#81BE66",
      },
      {
        index: 9,
        title: "Solutions Engineers",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin interdum, ipsum a fermentum cursus, sapien turpis condimentum lacus, et vehicula augue libero nec lorem.",
        color: "#E47C3A",
      }
    ];
   */
  useEffect(() => {
    console.log("zoneData " + zoneData);
    if (!zoneData || (Array.isArray(zoneData) && zoneData.length === 0) || (typeof zoneData === 'object' && Object.keys(zoneData).length === 0)) {
      setIsZonesPopulated(false);
      const wrapper = document.getElementById("left-container-wrapper");

        if ( wrapper) {
          wrapper.style.visibility = 'hidden'; // Hides the element but retains its space
          wrapper.style.opacity = '0'; // Makes the element fully transparent
          wrapper.style.maxHeight = '0.2vh'; 

        }
        const fullLeftComponent = document.getElementById("left-container");

        if ( fullLeftComponent) {
          fullLeftComponent.style.top='32vh'
          fullLeftComponent.style.bottom = '22vh'; 
        }
        const footerWrapper = document.getElementById("left-container-footer");

      if (footerWrapper) {
        footerWrapper.style.width = '19vw'
        footerWrapper.style.height = '44vh'
      }
      const elements = document.getElementsByClassName("outer-outer-1");

      if (elements.length > 0) {
        // Target the first element in the collection
        const footerQROuterWrapper = elements[0];
        footerQROuterWrapper.style.width = '10vw'
        footerQROuterWrapper.style.height = '20vh'
      }

      return;
    }
      
    const convertedZones = Object.keys(zoneData).map((key) => {
      const zone = zoneData[key];

      return {
        index: zone.order,
        title: zone.name,
        color: zone.colorValue,
        description: zone.description,
      };
    });

    setZones(convertedZones);
    setBuildingsAndFloors();
  }, []);


  const handleScroll = () => {
    const el = gridRef.current;
    if (el) {
      const isAtBottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 1;
      setAtBottom(isAtBottom);
    }
  };

  useEffect(() => {
    const el = gridRef.current;
    if (el) {
      el.addEventListener("scroll", handleScroll);
      return () => el.removeEventListener("scroll", handleScroll);
    }
  }, []);

  useEffect(() => {
    if(buildings.length<=0)
      return;
    console.log("**&buildings", buildings);
    setBuildingNameAndFloorNames();
    markCurrentPosition(map, long, lat, rotation, !isDestFidPopulated, pitch, bearing, whereAmIBuilding, whereAmILevel, whereAmIBuilding, whereAmILevel, 19, whereAmIScale);
  }, [buildings]);

  const handleToggleExpand = async (index, title) => {

    setExpandedZone(expandedZone === index ? null : index);

    if (!zoneData || !zoneData || expandedZone === index) {
      hidePopup();
      return;
    }
    const pointrWeb = window.PointrWebSDK.MapWidget.getInstance();
    const uiController = pointrWeb.getUiController();
    const mapViewController = uiController.getMapViewController();
    const mapView = mapViewController.getView();

    pointrWeb.unhighlight();

    const poiInfo = Object.keys(zoneData)
      .filter((key) => {
        const zone = zoneData[key];
        return title === zone.name;
      })
      .map((key) => {
        const zone = zoneData[key];
        return {
          fid: zone.features[0].properties.fid,
          name: zone.features[0].properties.name,
          coordinates: zone.features[0].geometry.coordinates[0],
        };
      });


    for (let i = 0; i < poiInfo.length; i++) {
      const feature = poiInfo[i];

      let valueAfterTilde;
      if (feature.fid.includes('~')) {
        valueAfterTilde = feature.fid.split('~')[1];
      } else {
        valueAfterTilde = feature.fid;
      }

      const poi = await pointrWeb.getPoiManager().get(valueAfterTilde);
      if (poi) {
        // mapViewController.highlightPoi(poi);
        pointrWeb.hidePoiDetails(poi);

        const latLong = calculateMidPoint(feature.coordinates);
        mapView.map.flyTo({
          center: [latLong.lng, latLong.lat],
          zoom: 19.2, pitch: pitch, bearing: bearing, speed: 0.4
        });
        showPopup(poi, calculateMidPoint(poi.geometry.coordinates[0]));
      } else {
        console.error("No valid poi found");
      }
    }

    //  mapViewController.highlightPoi(poi);
    //  pointrWeb.hidePoiDetails(poi);

  };

  const selectLevel = (buildingIndex, levelIndex, building, level) => {

    setSelectedLevels(({
      [activeTab]: levelIndex, // Store selected level per building (tab)
    }));
    setBuilding(buildingIndex);
    defaultBuilding = buildingIndex;
    const newLevel = parseInt(level.levelIndex);
    setLevel(newLevel);
    setSelectedFloor(newLevel);
    defaultLevel = newLevel;
    setBuildingName(building.buildingTitle);
    setLevelName(level.levelLongTitle);
   // setPopupVisible(false);
   map?.getUiController().getMapViewController()?.unhighlightAllPois();
   map?.getUiController().getMapViewController()?.removeAllMarkers();
   const mapView=map?.getUiController().getMapViewController()?.getView();
   mapView?.map.flyTo({   
    center: [centerLatLong[0] ,centerLatLong[1]
    ],
    zoom: 22, pitch: pitch, bearing: bearing, speed: 0.4
  });
    if (building.buildingTitle ===defaultBuildingTitle) {
      manageLayers(map?.getUiController().getMapViewController().getView(), null, newLevel)
     
      handleResetView(false);
    } else {
      manageLayers(map?.getUiController().getMapViewController().getView(), null, newLevel)
    }
    
    levelMapCenter(map, eventName, levelIndex);

    if (whereAmILevel !== level.levelIndex || whereAmILevel !== newLevel) {
      removeCurrentPosition(map.getUiController().getMapViewController().getView());
      if (building.buildingTitle === defaultBuildingTitle)
        manageLayers(map?.getUiController().getMapViewController().getView(), null, levelIndex)
      return;
    } else {
      markCurrentPosition(map, long, lat, rotation, true, pitch, bearing, whereAmIBuilding, whereAmILevel, whereAmIBuilding, whereAmILevel, 20.5, whereAmIScale);
    }
   
    
    // highlightBuildingFloor(map, buildings, buidling.buildingInternalIdentifier, newLevel);
    /*if (map) {
      mapView.map.flyTo({ center: [-115.1782890405586,36.088308032921276], zoom: 22.5, pitch: 65, bearing: 16 });
    }*/

  };
  const levelMapCenter = (map, eventName, levelIndex) => {
    switch(eventName){
     case "SFMC":{
      switch (levelIndex) {
        case 0:
        case 2: {
          map?.getUiController().getMapViewController().getView()?.map.flyTo({
            center: [  -89.57126304766972,37.303693991049045],
            zoom: 17,
            pitch: pitch, bearing: bearing, speed: 0.4
          });
        }
        break;
        case 1:
          {
            map?.getUiController().getMapViewController().getView()?.map.flyTo({
              center: [  -89.57126304766972,37.303693991049045],
              zoom: 18,
              pitch: pitch, bearing: bearing, speed: 0.4
            });
          }
          break;
        default:
              map?.getUiController().getMapViewController().getView()?.map.flyTo({
                center: [  -89.57126304766972,37.303693991049045],
                zoom: 17,
                pitch: pitch, bearing: bearing, speed: 0.4
              });
          
      }
    }
    break;
    case "CLEMEA":{
      switch (levelIndex) {
        case 2:
        case 3:
        case 4:
        case 5: {
          map?.getUiController().getMapViewController().getView()?.map.flyTo({
            center: [4.8897205960988686, 52.341317907321184],
            zoom: 17,
            pitch: pitch, bearing: bearing, speed: 0.4
          });
        }
        break;
        default:
              map?.getUiController().getMapViewController().getView()?.map.flyTo({
                center: [4.888230470000053, 52.341674505000015],
                zoom: 17,
                pitch: pitch, bearing: bearing, speed: 0.4
              });
          
      }
    }
    break;
    case "CLAMER":{
      switch (levelIndex) {
        case 0:
        case 2: {
          map?.getUiController().getMapViewController().getView()?.map.flyTo({
            center: [  -117.16157366402717, 32.7063196400436],
            zoom: 17,
            pitch: pitch, bearing: bearing, speed: 0.4
          });
        }
        break;
        case 1:
          {
            map?.getUiController().getMapViewController().getView()?.map.flyTo({
              center: [ -117.16315073647382, 32.70662305791154],
              zoom: 18,
              pitch: pitch, bearing: bearing, speed: 0.4
            });
          }
          break;
        default:
              map?.getUiController().getMapViewController().getView()?.map.flyTo({
                center:  [ -117.16157366402717, 32.7063196400436],
                zoom: 17,
                pitch: pitch, bearing: bearing, speed: 0.4
              });
          
      }
    }
    break;
    case "BGL-DEMO":{
      switch (levelIndex) {
        case 0:
        case 1: {
          map?.getUiController().getMapViewController().getView()?.map.flyTo({
            center: [ 77.69583683936298, 12.93267319626348],
            zoom: 20.5,
            pitch: pitch, bearing: bearing, speed: 0.4
          });
        }
        break;
        default:
              map?.getUiController().getMapViewController().getView()?.map.flyTo({
                center:  [77.69583683936298, 12.93267319626348],
                zoom: 20,
                pitch: pitch, bearing: bearing, speed: 0.4
              });
              break;
          
      }
    }
    break;
    case "NM-DEMO":{
      switch (levelIndex) {
        case 2:
        case 3:
        case 4:
        case 5: {
          map?.getUiController().getMapViewController().getView()?.map.flyTo({
            center: [ -87.62175027218564, 41.89460301448591],
            zoom: 17,
            pitch: pitch, bearing: bearing, speed: 0.4
          });
        }
        break;
        default:
              map?.getUiController().getMapViewController().getView()?.map.flyTo({
                center: [-87.62091065, 41.89431197],
                zoom: 17,
                pitch: pitch, bearing: bearing, speed: 0.4
              });
          
      }
    }
    break;
    case "HIMSS":{
      switch (levelIndex) {
        case 3:
        case 4: {
          map?.getUiController().getMapViewController().getView()?.map.flyTo({
            center: [-71.20197536651904, 42.18847461556646],
            zoom: 19,
            pitch: pitch, bearing: bearing, speed: 0.4
          });
        }
        break;
        default:
              map?.getUiController().getMapViewController().getView()?.map.flyTo({
                center: [-71.20138053510993, 42.189312619827774],
                zoom: 18,
                pitch: pitch, bearing: bearing, speed: 0.4
              });
          
      }
    }
    break;
    case "SJC-DEMO":{
      switch (levelIndex) {
        case 0: {
          map?.getUiController().getMapViewController().getView()?.map.flyTo({
            center: [-121.9191846089422, 37.41896623582046],
            zoom: 19,
            pitch: pitch, bearing: bearing, speed: 0.4
          });
        }
        break;
        default:
              map?.getUiController().getMapViewController().getView()?.map.flyTo({
                center: [-121.9191846089422, 37.41896623582046],
                zoom: 17.5,
                pitch: pitch, bearing: bearing, speed: 0.4
              });
          
      }
    }
    break;
    default: {
      switch (levelIndex) {
        case 2: {
          window.PointrWebSDK.MapWidget.getInstance().uiController.mapViewController.scrollToBuilding(2)
          map?.getUiController().getMapViewController().getView()?.map.flyTo({
            center: [144.952256625269, -37.82485657607955],
            zoom: 19,
            pitch: 60, bearing: -108.19999999999993, speed: 0.4
          });
        }
          break;
        case 4: {
          window.PointrWebSDK.MapWidget.getInstance().uiController.mapViewController.scrollToBuilding(3)
          map?.getUiController().getMapViewController().getView()?.map.flyTo({
            center: [144.9556658132126, -37.82432439740382],
            zoom: 20,
            pitch: pitch, bearing: bearing, speed: 0.4
          });
        }
          break;
        default:
          {
            if (defaultBuildingTitle !== "Melbourne Convention and Exhibition Center") {
              map?.getUiController().getMapViewController().getView()?.map.flyTo({
                center: [4.888230470000053, 52.341674505000015],
                zoom: 18,
                pitch: pitch, bearing: bearing, speed: 0.4
              });


            } else {
              map?.getUiController().getMapViewController().getView()?.map.flyTo({
                center: [144.9517690909911, -37.825261908812955],
                zoom: 18,
                pitch: pitch, bearing: bearing, speed: 0.4
              });
            }
          }
      }
    }


    }
 
  }
  useEffect(() => {
    if (enableLevelSelector) {
      // Check if the active building title is "Melbourne Convention and Exhibition Center" and it has levels
      if (buildings[activeTab]?.buildingTitle === defaultBuildingTitle && buildings[activeTab]?.levels?.length > 0) {

        // Automatically select the first level (index 0)
        if (enableLevelSelector) {
          setActiveTab(activeTab);
          selectLevel(buildings[activeTab]?.buildingInternalIdentifier, buildings[activeTab].levels[0].levelIndex, buildings[activeTab], buildings[activeTab].levels[0]);

        }
      }
    } else {
      setBuildingNameAndFloorNames();
    }
  }, [activeTab]);

  let isBuildingDataSet = false; // Flag to track if buildings are successfully set
  let retryCount = 0; // Counter for retries
  const maxRetries = 10; // Maximum number of retries allowed
  const retryDelay = 1000; // Delay between retries in milliseconds
  

  const setBuildingsAndFloors = () => {
   /** // Check if map is available and retry if it's still null
    if (!map) {
      console.error(`**&Map is not available. Retrying in ${retryDelay}ms... (${retryCount + 1}/${maxRetries})`);
      retryCount++;
      
      if (retryCount < maxRetries) {
        setTimeout(setBuildingsAndFloors, retryDelay); // Retry after the delay
      } else {
        console.error(`**&Max retries reached (${maxRetries}). Stopping attempts to access map.`);
      }
      return; // Exit the function since map is not ready
    }
  
    // Stop further processing if buildings are already set
    if (isBuildingDataSet || buildings.length > 0) return;
   */
    try {
      var fetchedBuildings = [];
      if (buildingInfo) {
        fetchedBuildings = buildingInfo;
      } else {
        fetchedBuildings = map?.siteBuildingManager?.getAllBuildings();
      }

      if (fetchedBuildings?.length > 0) {
        const clonedBuilding = {
          ...fetchedBuildings[0],
          buildingTitle: defaultBuildingTitle,
          levels: listAllAvailableLevels(fetchedBuildings)
        };
        if(clonedBuilding.levels?.length > 1){
          setEnableLevelSelector(true);
        }
        
  
        fetchedBuildings = [clonedBuilding];
  
        if (buildings.length === 0) {
          setBuildings(fetchedBuildings);
          isBuildingDataSet = true; // Set the flag to true to prevent re-execution
        }
      
      }  else {
       // setEnableLevelSelector(false);
      }
  
      setBuildingNameAndFloorNames();
      scrollToBottom();
    } catch (error) {
      console.error("**&An error occurred while processing in setBuildingsAndFloors:", error);
      
      // Increment retry counter and retry if limit not yet reached
      retryCount++;
      if (retryCount < maxRetries) {
        setTimeout(setBuildingsAndFloors, retryDelay); // Retry after delay in case of error
      } else {
        console.warn(`**&Max retries reached (${maxRetries}). Stopping further attempts.`);
      }
    }
  };

  const setBuildingNameAndFloorNames = () => {
    if (buildings && buildings[activeTab] && buildings[activeTab]?.levels[0]) {
      setBuildingName(buildings[activeTab]?.buildingTitle);
      if (buildings[0]?.buildingTitle === "Mandalay Bay" && "Level 1" === buildings[0]?.levels[0]?.levelLongTitle) {
        setLevelName("The Hub")
      } else {
        setLevelName(buildings[activeTab]?.levels?.find(level => level.levelIndex === defaultLevel)?.levelLongTitle);
        setLevel(buildings[activeTab]?.levels?.find(level => level.levelIndex === defaultLevel)?.levelIndex);
      }
    }
  }
  useEffect(() => {
    if (!isQrCodeGenerated) {
      setIsQrCodeGenerated(true);
    }
  }, [isQrCodeGenerated]);

  const requestBody = ((new Date().getTime() / 1000) > qrCodeExpiresAt) ? {
    tenantId: tenantId,
    locationId: locationId
  }:{
    tenantId: tenantId,
    locationId: locationId,
    expiresAt: qrCodeExpiresAt
  };

  useEffect(() => {
    let timeoutId;
    if (expandedZone !== null) {
      timeoutId = setTimeout(() => {
       // handleToggleExpand(expandedZone);
        setExpandedZone(null);

      }, 15000);
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [expandedZone]);

  function scrollToBottom() {
    if(eventName==="BGL-DEMO")
      return
    const container = document.querySelector(".left-container-level-selector-section-items");

    if (container) {
      const observer = new MutationObserver(() => {
        container.scrollTop = container.scrollHeight;
      });
    
      observer.observe(container, { childList: true });
    } else {
     // console.warn("Element .left-container-level-selector-section-items not found.");
    }
    
  }

  return (
    <div className={`left-container ${isActive ? 'active' : ''}`} id="left-container">
      {isActive && <div className="background-blur-left-qr" />}
      {enableLevelSelector ?
        (
          <div className="left-container-level-selector" id="left-container-level-selector"
           style={{
            height: (eventName === "BGL-DEMO"? '28vh' :'54vh')  // Adjust heights as needed
          }} >
            <div className="left-container-level-selector-section-header">
              <h1>{defaultBuildingTitle}</h1>
              {buildingInfo?.length > 1 &&<h2>{"Choose Floor"}</h2>}
            </div>
            {/**buildingInfo?.length > 1 && (<div className="left-container-building-selector">
              <img src={leftNav} className="left-container-building-selector-left-nav">
              </img>
              {"Building " + (activeTab + 1)}
              <img src={rightNav} className="left-container-building-selector-right-nav">
              </img>
        </div>)*/}
            <div
              className="left-container-level-selector-section-items"
              style={{
                height: buildingInfo?.length > 1 ? '75%' : (eventName === "BGL-DEMO"?'70%' :'90%') // Adjust heights as needed
              }}
            >

              {buildings[activeTab]?.levels.slice().reverse().map(
                (lvl, index) => (
                  <div
                  key={index}
                  className={`left-container-level-selector-item ${selectedLevels[activeTab] === lvl.levelIndex ? "expanded" : ""}`}
                  onClick={() => {
                    selectLevel(buildings[activeTab]?.buildingInternalIdentifier, lvl.levelIndex, buildings[activeTab], lvl);
                    setSelectedFloor(lvl.levelIndex);
                  }}
                  style={{
                    borderColor: floorColourMapping.find(item => item.levelIndex === lvl.levelIndex)?.color,
                  //  borderColor: (floorColourMapping.find(item => item.levelIndex === lvl.levelIndex)?.enableDisplayBullet??true)? floorColourMapping.find(item => item.levelIndex === lvl.levelIndex)?.color: '#000000',

                    justifyContent: (floorColourMapping.find(item => item.levelIndex === lvl.levelIndex)?.enableDisplayBullet??true)? 'left': 'center',
                    backgroundColor: (floorColourMapping.find(item => item.levelIndex === lvl.levelIndex)?.enableDisplayBullet??true)? '#2A2F33':'#000000',
                    paddingLeft: (floorColourMapping.find(item => item.levelIndex === lvl.levelIndex)?.enableDisplayBullet??true)? '1vw':'0vw'
                  }}  
                  >
                    {(floorColourMapping.find(item => item.levelIndex === lvl.levelIndex)?.enableDisplayBullet??true) ? (
                      <div
                        className="left-container-level-selector-item-solid-rectangle"
                        style={{
                          backgroundColor: floorColourMapping.find(item => item.levelIndex === lvl.levelIndex)?.color || "transparent"
                        }}
                      >
                      </div>
                    ):(<></>)}

                  <div className="left-container-level-selector-item-name"> {floorNameMapping[lvl.levelIndex]}</div>
                  
                  {selectedFloor === lvl.levelIndex && 
                  <div className="left-container-level-selector-item-floor-marker">
                    <SelectedMarker   strokeColor={floorColourMapping.find(item => item.levelIndex === lvl.levelIndex)?.color} fillColor={floorColourMapping.find(item => item.levelIndex === lvl.levelIndex)?.fillColor ?? "none"}/>   </div>}
                  </div>    
              ))}
            </div>
          </div>
        ) :
        (
          <div className="left-container-wrapper" id="left-container-wrapper" >
            <div className="section-header">
              <h1>Zones</h1>
              <h2>Tap to know more</h2>
            </div>
            <div className="section-items" ref={gridRef}
             style={{
              WebkitMaskImage: atBottom
                ? "linear-gradient(to top, black 65%, transparent 100%)"
                : "linear-gradient(to bottom, black 65%, transparent 100%)",
              maskImage: atBottom
                ? "linear-gradient(to top, black 65%, transparent 100%)"
                : "linear-gradient(to bottom, black 65%, transparent 100%)",
            }}
             >
              {zones.map((zone) => (
                <div
                  key={zone.index}
                  className={`left-container-item ${expandedZone === zone.index ? "expanded" : ""
                    }`}
                  onClick={() => handleToggleExpand(zone.index, zone.title)}
                >
                  <div className="left-container-item-left" onClick={(e) => {
                    handleToggleExpand(zone.index, zone.title);
                  }} >
                    <div className="pin-icon">
                      <div
                        className="circle-badge"
                        style={{ backgroundColor: zone.color, color: zone.color === '#FFFFFF' ? '#00000' : '#FFFFFF' }}
                      >
                        {zone.index}
                      </div>
                    </div>
                  </div>
                  <div className="left-container-item-right" onClick={(e) => {
                    handleToggleExpand(zone.index, zone.title);
                  }}>
                    <div className={`left-container-item-right-title ${expandedZone === zone.index ? "" : ""
                      }`}>
                      {zone.title}
                    </div>
                    <div
                      className={`left-container-item-right-description ${expandedZone === zone.index ? "" : ""
                        }`}
                    >
                      {zone.description}
                    </div>

                  </div>
                  <div className="arrow-container" onClick={(e) => {
                    handleToggleExpand(zone.index, zone.title);
                  }}>
                    <ArrowIcon direction={expandedZone === zone.index ? "up" : "down"} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      

      <div className={`left-container-footer${isActive ? '-active' : ''}`} id="left-container-footer"
        onClick={handleTap}>

            <div className="left-container-footer-inner-top">
              <div className="left-container-footer-inner-top-left">
                <p className="left-container-footer-inner-top-left">Navigate <br />on your phone</p>
                <div className="left-container-footer-inner-top-left-bottom">
                  <p className="left-container-footer-inner-top-left-bottom">Please close your current app<br /> before scanning QR Code</p>
                </div>
              </div>

            </div>
            <div className="left-container-footer-inner-outer-container"  >
              <div className={`outer-outer-1${isActive ? '-active' : ''}`} ></div>
              {isQrCodeGenerated && (
                <QrCodeComponent
                  tenant={tenantId}
                  location={locationId}
                  requestBody={requestBody}
                  canvasId={`outer-bottom${isActive ? '-active' : ''}`}
                  className={`outer-bottom${isActive ? '-active' : ''}`}
                  isZonesPopulated={isZonesInfoPopulated}
                  signageNum={signageNum}
                />
              )}
            </div>
            <div className={`left-container-footer-inner-bottom${isActive ? '-active' : ''}`}>
              {isActive && <svg width="60" height="33" viewBox="0 0 97 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.993381" y="0.959934" width="95.3571" height="30.4528" rx="15.2264" stroke="#FFFFFF" stroke-width="1.23041" />
                <path d="M25.7463 19.8464L21.4715 15.5709L25.7463 11.2956L23.8698 9.41895L19.5947 13.694L15.3196 9.41895L13.443 11.2956L17.7182 15.5709L13.4421 19.8464L15.3186 21.7229L19.5947 17.4472L23.8698 21.7229L25.7463 19.8464Z" fill="white" />
                <path d="M43.7225 12.7168C43.6766 12.4067 43.5732 12.1254 43.4125 11.8727C43.2517 11.6086 43.0507 11.3789 42.8096 11.1837C42.5684 10.9885 42.2928 10.8392 41.9827 10.7358C41.6842 10.621 41.3683 10.5636 41.0353 10.5636C40.4267 10.5636 39.9099 10.6842 39.485 10.9253C39.0601 11.155 38.7156 11.4708 38.4514 11.8727C38.1873 12.2632 37.9921 12.7111 37.8658 13.2164C37.7509 13.7216 37.6935 14.2442 37.6935 14.7839C37.6935 15.3007 37.7509 15.806 37.8658 16.2998C37.9921 16.7821 38.1873 17.2185 38.4514 17.6089C38.7156 17.9994 39.0601 18.3152 39.485 18.5564C39.9099 18.786 40.4267 18.9009 41.0353 18.9009C41.8622 18.9009 42.5052 18.6482 42.9646 18.1429C43.4354 17.6376 43.7225 16.9716 43.8259 16.1447H46.4442C46.3753 16.9142 46.1973 17.6089 45.9102 18.2291C45.6231 18.8492 45.2442 19.3774 44.7733 19.8138C44.3025 20.2502 43.7512 20.5833 43.1196 20.8129C42.488 21.0426 41.7932 21.1574 41.0353 21.1574C40.0936 21.1574 39.2438 20.9967 38.4859 20.6751C37.7394 20.3421 37.1078 19.8885 36.5911 19.3143C36.0743 18.7401 35.6781 18.0683 35.4025 17.2989C35.1269 16.518 34.9891 15.6796 34.9891 14.7839C34.9891 13.8652 35.1269 13.0154 35.4025 12.2345C35.6781 11.4421 36.0743 10.7531 36.5911 10.1674C37.1078 9.58171 37.7394 9.12235 38.4859 8.78932C39.2438 8.45629 40.0936 8.28977 41.0353 8.28977C41.7129 8.28977 42.3502 8.38738 42.9474 8.58261C43.556 8.77783 44.0958 9.06493 44.5666 9.4439C45.0489 9.81138 45.4451 10.2707 45.7552 10.822C46.0652 11.3732 46.2605 12.0048 46.3409 12.7168H43.7225ZM48.1015 8.58261H50.5476V20.8818H48.1015V8.58261ZM54.6441 16.4376C54.6441 16.7936 54.6786 17.1438 54.7475 17.4884C54.8164 17.8214 54.9312 18.1257 55.092 18.4013C55.2642 18.6654 55.4882 18.8779 55.7638 19.0387C56.0394 19.1994 56.3839 19.2798 56.7973 19.2798C57.2107 19.2798 57.5553 19.1994 57.8309 19.0387C58.118 18.8779 58.3419 18.6654 58.5027 18.4013C58.6749 18.1257 58.7955 17.8214 58.8644 17.4884C58.9333 17.1438 58.9678 16.7936 58.9678 16.4376C58.9678 16.0816 58.9333 15.7313 58.8644 15.3868C58.7955 15.0423 58.6749 14.738 58.5027 14.4738C58.3419 14.2097 58.118 13.9973 57.8309 13.8365C57.5553 13.6642 57.2107 13.5781 56.7973 13.5781C56.3839 13.5781 56.0394 13.6642 55.7638 13.8365C55.4882 13.9973 55.2642 14.2097 55.092 14.4738C54.9312 14.738 54.8164 15.0423 54.7475 15.3868C54.6786 15.7313 54.6441 16.0816 54.6441 16.4376ZM52.198 16.4376C52.198 15.7256 52.3071 15.0825 52.5253 14.5083C52.7435 13.9226 53.0536 13.4288 53.4555 13.0269C53.8575 12.6134 54.3398 12.2976 54.9025 12.0794C55.4652 11.8498 56.0968 11.7349 56.7973 11.7349C57.4978 11.7349 58.1295 11.8498 58.6922 12.0794C59.2664 12.2976 59.7544 12.6134 60.1564 13.0269C60.5583 13.4288 60.8684 13.9226 61.0866 14.5083C61.3047 15.0825 61.4138 15.7256 61.4138 16.4376C61.4138 17.1496 61.3047 17.7927 61.0866 18.3669C60.8684 18.9411 60.5583 19.4349 60.1564 19.8483C59.7544 20.2502 59.2664 20.5603 58.6922 20.7785C58.1295 20.9967 57.4978 21.1058 56.7973 21.1058C56.0968 21.1058 55.4652 20.9967 54.9025 20.7785C54.3398 20.5603 53.8575 20.2502 53.4555 19.8483C53.0536 19.4349 52.7435 18.9411 52.5253 18.3669C52.3071 17.7927 52.198 17.1496 52.198 16.4376ZM64.8991 17.9879C64.8991 18.252 64.9508 18.4817 65.0541 18.6769C65.169 18.8607 65.3125 19.0157 65.4848 19.142C65.657 19.2569 65.8523 19.343 66.0705 19.4004C66.3001 19.4578 66.5356 19.4865 66.7767 19.4865C66.949 19.4865 67.127 19.4693 67.3107 19.4349C67.5059 19.3889 67.6782 19.3258 67.8275 19.2454C67.9883 19.1535 68.1203 19.0387 68.2237 18.9009C68.327 18.7516 68.3787 18.5678 68.3787 18.3496C68.3787 17.9822 68.1318 17.7065 67.638 17.5228C67.1557 17.3391 66.4781 17.1553 65.6054 16.9716C65.2494 16.8912 64.8991 16.7993 64.5546 16.696C64.2216 16.5811 63.923 16.4376 63.6589 16.2653C63.3947 16.0816 63.1823 15.8576 63.0215 15.5935C62.8607 15.3179 62.7803 14.9849 62.7803 14.5944C62.7803 14.0202 62.8894 13.5494 63.1076 13.1819C63.3373 12.8144 63.6359 12.5273 64.0034 12.3206C64.3709 12.1024 64.7843 11.9531 65.2436 11.8727C65.703 11.7809 66.1738 11.7349 66.6561 11.7349C67.1385 11.7349 67.6036 11.7809 68.0514 11.8727C68.5108 11.9646 68.9185 12.1196 69.2745 12.3378C69.6305 12.556 69.9233 12.8489 70.153 13.2164C70.3941 13.5724 70.5377 14.026 70.5836 14.5772H68.2581C68.2237 14.1064 68.0457 13.7905 67.7241 13.6298C67.4026 13.4575 67.0236 13.3714 66.5872 13.3714C66.4494 13.3714 66.3001 13.3829 66.1394 13.4058C65.9786 13.4173 65.8293 13.4518 65.6915 13.5092C65.5652 13.5666 65.4561 13.6527 65.3642 13.7676C65.2723 13.8709 65.2264 14.0145 65.2264 14.1982C65.2264 14.4164 65.3068 14.5944 65.4676 14.7322C65.6283 14.87 65.835 14.9849 66.0877 15.0767C66.3518 15.1571 66.6504 15.2318 66.9834 15.3007C67.3165 15.3696 67.6552 15.4442 67.9998 15.5246C68.3558 15.605 68.7003 15.7026 69.0333 15.8174C69.3778 15.9323 69.6821 16.0873 69.9463 16.2825C70.2104 16.4663 70.4229 16.7017 70.5836 16.9888C70.7444 17.2644 70.8248 17.6089 70.8248 18.0224C70.8248 18.608 70.7042 19.1018 70.463 19.5038C70.2334 19.8942 69.929 20.21 69.5501 20.4512C69.1711 20.6924 68.7347 20.8589 68.2409 20.9507C67.7586 21.0541 67.2648 21.1058 66.7595 21.1058C66.2427 21.1058 65.7374 21.0541 65.2436 20.9507C64.7498 20.8474 64.3077 20.6751 63.9172 20.434C63.5383 20.1928 63.2225 19.877 62.9698 19.4865C62.7287 19.0846 62.5966 18.5851 62.5736 17.9879H64.8991ZM78.251 15.4729C78.1362 14.8528 77.9294 14.382 77.6309 14.0604C77.3438 13.7389 76.9016 13.5781 76.3045 13.5781C75.914 13.5781 75.5867 13.647 75.3226 13.7848C75.07 13.9111 74.8633 14.0719 74.7025 14.2671C74.5532 14.4624 74.4441 14.6691 74.3752 14.8873C74.3178 15.1054 74.2833 15.3007 74.2718 15.4729H78.251ZM74.2718 17.0233C74.3063 17.8156 74.5073 18.3898 74.8747 18.7458C75.2422 19.1018 75.7705 19.2798 76.4595 19.2798C76.9533 19.2798 77.3782 19.1593 77.7342 18.9181C78.0902 18.6654 78.3084 18.4013 78.3888 18.1257H80.542C80.1975 19.1937 79.6693 19.9574 78.9573 20.4167C78.2453 20.8761 77.384 21.1058 76.3734 21.1058C75.6729 21.1058 75.0413 20.9967 74.4785 20.7785C73.9158 20.5488 73.4393 20.2273 73.0488 19.8138C72.6584 19.4004 72.354 18.9066 72.1358 18.3324C71.9291 17.7582 71.8258 17.1266 71.8258 16.4376C71.8258 15.7715 71.9349 15.1514 72.1531 14.5772C72.3713 14.003 72.6813 13.5092 73.0833 13.0958C73.4852 12.6709 73.9618 12.3378 74.513 12.0967C75.0757 11.8555 75.6958 11.7349 76.3734 11.7349C77.1313 11.7349 77.7916 11.8842 78.3544 12.1828C78.9171 12.4699 79.3764 12.8604 79.7324 13.3542C80.0999 13.848 80.364 14.4107 80.5248 15.0423C80.6856 15.6739 80.743 16.3342 80.6971 17.0233H74.2718Z" fill="white" />
              </svg>}
              {isActive ? '' : 'Tap to expand'}</div>
      </div>

    </div>
  )
};

export default LeftContainer;
